import Skeleton from '@mui/material/Skeleton';
import { formatTranslation } from 'intl';
import { DocumentationTranslationKeys } from 'intl/keys';
import { DocumentationFile } from 'store/documentation/model/types';
import { useLevels } from 'store/level';
import { useSites } from 'store/site';
import { MemoPreviewField } from 'components/general/PreviewField';
import { ReactElement } from 'react';
import { useIntl } from 'react-intl';
import { useProjectTimezone } from 'store/project';
import { findDocumentationOnLevelsAndSites } from 'shared/domain/documentation/findDocumentationOnLevels';
import { LabelledEntity } from 'shared/types/commonView';
import { ISO6391LanguageCode } from 'shared/types/locale';
import { toLocalizedDateDisplayStringFormatWithTime } from 'shared/utils/date/dates';
import { FieldTranslationKeys } from 'intl/keys';

export function DocumentationInformationPreview({
  file,
}: {
  file: DocumentationFile;
}): ReactElement {
  const intl = useIntl();
  const { loading: loadingSites, items: sites } = useSites();
  const { loading: loadingLevels, items: levels } = useLevels();
  const timezone = useProjectTimezone();

  if (loadingSites || loadingLevels) {
    return (
      <>
        <div className='row'>
          <Skeleton variant='text' width={'100%'} height={48} />
        </div>
        <div className='row'>
          <Skeleton variant='text' width={'100%'} height={48} />
        </div>
        <div className='row'>
          <Skeleton variant='text' width={'100%'} height={48} />
        </div>
        <div className='row'>
          <Skeleton variant='text' width={'100%'} height={48} />
        </div>
      </>
    );
  }

  const documentationId = file.documentationId;
  const versionId = file.versionId;

  const { sitesValue, levelsValue } = findDocumentationOnLevelsAndSites(
    levels,
    sites,
    documentationId
  );

  return (
    <>
      <div className='row'>
        <MemoPreviewField
          label={formatTranslation(intl, FieldTranslationKeys.site )}
          value={sitesValue.map((site: LabelledEntity) => site.label)}
          dense={false}
        />
      </div>
      <div className='row'>
        <MemoPreviewField
          label={formatTranslation(intl, FieldTranslationKeys.level )}
          value={levelsValue.map((level: LabelledEntity) => level.label)}
          dense={false}
        />
      </div>
      <div className='row'>
        <MemoPreviewField
          label={formatTranslation(intl, DocumentationTranslationKeys.creationDate)}
          dense={true}
          value={toLocalizedDateDisplayStringFormatWithTime(
            file.createdAt,
            timezone,
            intl.locale as ISO6391LanguageCode
          )}
        />
      </div>
      <div className='row'>
        <MemoPreviewField
          label={formatTranslation(intl, DocumentationTranslationKeys.author)}
          value={file.createdBy?.label || ' '}
          dense={false}
        />
      </div>
    </>
  );
}
